import React from 'react'

const CallLogIcon = () => (
  <svg
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    focusable="false"
  >
    <path
      d={'M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 ' +
      '16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 ' +
      '2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 ' +
      '1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 ' +
      '3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 ' +
      '1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 ' +
      '.53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 ' +
      '0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 ' +
      '1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 ' +
      '4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z'}
    />
  </svg>
)

export default CallLogIcon



// WEBPACK FOOTER //
// ./src/components/assets/CallLogIcon.js